module.exports = __webpack_public_path__ + "img/9.8591f1f6.jpg";